import storage from '../Firebase/storage';
import {IMAGES_DIRECTORY} from '../Constants/appConstants';

export const downloadPhoto = async (imageRef: string): Promise<string> => {
  // check if image ref is really an image ref
  if (imageRef.startsWith(IMAGES_DIRECTORY))
    return storage().ref(imageRef).getDownloadURL();
  else return imageRef;
};
